import Vue from 'vue';
import Karteieintrag from '@/types/Karteieintrag';

export default class OffeneVerrechnung extends Karteieintrag {
    public nachname?: string | null;
    public vorname?: string | null;
    public geburtsdatum?: string | null;
    public verrechnungs_kz?: string | null;

    public get Geburtsdatum(): string {
        return Vue.prototype.$d(this.geburtsdatum);
    }

    public get Impfdatum(): string {
        return Vue.prototype.$d(this.impfdatum);
    }

    constructor(data?: Partial<OffeneVerrechnung>) {
        super(data);
        Object.assign(this, data);
    }
}
